module.exports = __webpack_public_path__ + "assets/img/study_2.7a8a0f41.png";